import { OrderKeys } from '../OrderKeys';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export const siteUserSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'siteRole': createNonDisplayOptionDefinition('siteRole', OrderKeys.siteRole),
  'groupCount': createNonDisplayOptionDefinition('groupCount', OrderKeys.groupCount),
  'lastSignIn': createNonDisplayOptionDefinition('lastSignIn', OrderKeys.lastSignIn),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
};
